import { cn } from "@/lib/utils";
import * as React from "react";

const Progress = ({ className, value, indicatorClassName, ...props }) => (
  <div
    className={cn(
      "relative h-1 w-full overflow-hidden rounded-full bg-nxstart-green/20",
      className,
    )}
    {...props}
  >
    <div
      className={cn(
        "absolute h-full w-full flex-1 bg-secondary dark:bg-primary transition-all",
        indicatorClassName,
      )}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </div>
);

export default Progress;
